
<div>
  <h4>Basic Settings</h4>
  <div>
    <div class="label">Board Title</div>
    <input @input="isDirty = true" type="text" class="form-control" v-model="settings.title" />
  </div>
  <div>
    <div class="label mt-2 mb-1">Enable Shifts</div>
    <checkbox-with-label
      :label="'Enable Shifts'"
      v-model="settings.enableShifts"
      @input="(value) => (isDirty = true)"
    ></checkbox-with-label>
  </div>

  <div>
    <div class="label mt-2 mb-1">Send "InProgress" Tasks back to "Tasks" on shift handover</div>
    <checkbox-with-label
      :label="'Enable automatic move of In Progress tasks back to Tasks on shift handover'"
      v-model="settings.enableAutomaticStatusChangeOnShiftHandover"
      @input="(value) => (isDirty = true)"
    ></checkbox-with-label>
  </div>

  <hr />
  <div class="d-flex justify-content-end pt-3">
    <button :disabled="!isDirty" class="btn btn-save btn-sm btn-success" @click="save()">
      <i class="far fa-save"></i>
      Save changes
    </button>
  </div>
</div>
